import type { ProfessionalBillingCycle } from './commercial-intent.ts';

export type PricingLocale = 'it' | 'en' | 'ar';

// Presentation only. Stripe's server-configured Price IDs remain authoritative
// for the amount charged by a newly created Checkout Session.
export const PROFESSIONAL_PRICING_USD = {
  currency: 'USD',
  monthly: 49,
  annual: 490,
  monthlyAnnualized: 588,
  annualSaving: 98,
  annualEffectiveMonthly: 40.83,
  annualSavingPercent: 98 / 588 * 100,
} as const;

export const PROFESSIONAL_LAUNCH_MONTHLY_USD = 39;
export const PROFESSIONAL_LAUNCH_ANNUAL_USD = 390;

export function professionalPricing(cycle: ProfessionalBillingCycle, locale: PricingLocale = 'it') {
  const amount = PROFESSIONAL_PRICING_USD[cycle];
  const label = locale === 'it'
    ? `${amount} USD/${cycle === 'monthly' ? 'mese' : 'anno'}`
    : locale === 'ar'
      ? `${amount} دولارًا ${cycle === 'monthly' ? 'شهريًا' : 'سنويًا'}`
      : `$${amount}/${cycle === 'monthly' ? 'month' : 'year'}`;
  return { amount, label, currency: PROFESSIONAL_PRICING_USD.currency };
}

export function professionalLaunchMonthlyLabel(locale: PricingLocale = 'it'): string {
  return locale === 'it' ? `${PROFESSIONAL_LAUNCH_MONTHLY_USD} USD/mese`
    : locale === 'ar' ? `${PROFESSIONAL_LAUNCH_MONTHLY_USD} دولارًا شهريًا`
      : `$${PROFESSIONAL_LAUNCH_MONTHLY_USD}/month`;
}

export function professionalLaunchAnnualLabel(locale: PricingLocale = 'it'): string {
  return locale === 'it' ? `${PROFESSIONAL_LAUNCH_ANNUAL_USD} USD/anno`
    : locale === 'ar' ? `${PROFESSIONAL_LAUNCH_ANNUAL_USD} دولارًا سنويًا`
      : `$${PROFESSIONAL_LAUNCH_ANNUAL_USD}/year`;
}

export function professionalAnnualSavingLabel(locale: PricingLocale): string {
  const amount = PROFESSIONAL_PRICING_USD.annualSaving;
  return locale === 'it' ? `Risparmia ${amount} USD all’anno`
    : locale === 'ar' ? `وفّر ${amount} دولارًا سنويًا` : `Save $${amount} per year`;
}

export function professionalAnnualEffectiveMonthlyLabel(locale: PricingLocale): string {
  const amount = PROFESSIONAL_PRICING_USD.annualEffectiveMonthly;
  return locale === 'it' ? `Equivalente a ${amount.toFixed(2).replace('.', ',')} USD/mese`
    : locale === 'ar' ? `ما يعادل ${amount.toFixed(2)} دولارًا شهريًا` : `Equivalent to $${amount.toFixed(2)}/month`;
}
